import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as r } from "react";
const c = ({
  title: l,
  titleId: o,
  ...s
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M265.094 540.081c-78.507-78.507-78.507-206.229 0-284.736 38.016-38.037 88.576-58.965 142.357-58.965s104.32 20.949 142.379 58.965c78.485 78.507 78.485 206.229 0 284.736-38.059 38.016-88.597 58.987-142.379 58.987s-104.341-20.971-142.357-58.987m567.915 225.685L636.657 569.393c37.099-49.301 57.472-108.864 57.472-171.691 0-76.565-29.824-148.544-83.968-202.688s-126.123-83.968-202.709-83.968c-76.565 0-148.565 29.824-202.688 83.968-54.144 54.144-83.968 126.123-83.968 202.688 0 76.587 29.824 148.565 83.968 202.709 54.123 54.144 126.123 83.989 202.688 83.989 61.461 0 119.765-19.499 168.448-55.083l196.779 196.779c8.341 8.341 19.243 12.501 30.165 12.501s21.824-4.16 30.165-12.501c16.661-16.661 16.661-43.669 0-60.331z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = r(c);
export {
  n as default
};
